import { useMemo } from 'react';
import { useHashRoute } from './router.js';
import { FixtureApi } from './data/FixtureApi.js';
import type { PortalApi } from './data/types.js';
import { Invitation } from './screens/Invitation.js';
import { Submit } from './screens/Submit.js';
import { Respond } from './screens/Respond.js';
import { SharedRecord } from './screens/SharedRecord.js';

const TABS = ['invitation', 'submit', 'respond', 'shared'] as const;
type Tab = (typeof TABS)[number];

const TAB_LABEL: Record<Tab, string> = {
  invitation: 'invitation',
  submit: 'submit',
  respond: 'respond to flag',
  shared: 'shared record',
};

export function App({ api = new FixtureApi() as PortalApi }: { api?: PortalApi } = {}) {
  const [tab, nav] = useHashRoute<Tab>(TABS, 'invitation');
  const ctx = useMemo(() => api, [api]);

  return (
    <div style={{ background: 'var(--paper)', minHeight: '100vh', color: 'var(--ink)', fontFamily: 'var(--body)' }}>
      <div style={{ maxWidth: 880, margin: '0 auto', padding: '28px 24px 64px' }}>
        <div
          className="panel"
          style={{
            padding: '14px 18px',
            marginBottom: 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 12,
            flexWrap: 'wrap',
          }}
        >
          <div>
            <div
              style={{
                fontFamily: 'var(--mono)',
                fontSize: 10.5,
                letterSpacing: '.1em',
                textTransform: 'uppercase',
                color: 'var(--muted)',
              }}
            >
              Supplier portal
            </div>
            <div style={{ fontFamily: 'var(--display)', fontWeight: 600, fontSize: 16, marginTop: 3 }}>
              Medisource Trading FZE
            </div>
          </div>
          <div style={{ fontFamily: 'var(--mono)', fontSize: 11.5, color: 'var(--muted)', textAlign: 'right' }}>
            invited by Lench Procurement
            <br />
            deal · DEAL-4471
          </div>
        </div>

        <nav aria-label="Portal sections" style={{ display: 'flex', gap: 6, marginBottom: 18, flexWrap: 'wrap' }}>
          {TABS.map((t) => {
            const active = tab === t;
            return (
              <button
                key={t}
                onClick={() => nav(t)}
                aria-pressed={active}
                style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 11,
                  fontWeight: 600,
                  letterSpacing: '.03em',
                  padding: '7px 12px',
                  borderRadius: 'var(--radius-md)',
                  cursor: 'pointer',
                  border: `1px solid ${active ? 'var(--ink)' : 'var(--rule)'}`,
                  background: active ? 'var(--ink)' : 'var(--panel)',
                  color: active ? 'var(--paper)' : 'var(--muted)',
                }}
              >
                {TAB_LABEL[t]}
              </button>
            );
          })}
        </nav>

        {tab === 'invitation' && <Invitation api={ctx} onAccept={() => nav('submit')} />}
        {tab === 'submit' && <Submit api={ctx} onSubmitted={() => nav('shared')} />}
        {tab === 'respond' && <Respond api={ctx} />}
        {tab === 'shared' && <SharedRecord api={ctx} />}
      </div>
    </div>
  );
}
